import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { translate } from 'react-i18next';
import { compose } from 'recompose';
import { Link } from 'react-router-dom';
import axios from 'axios';
import moment from 'moment-timezone';
import LogoPro from '../../images/pro.png';
import LogoPlus from '../../images/plus.png';
import Logostart from '../../images/start.png';

import * as $ from 'jquery';
import HelpContainer from './../HelpContainer';



let cancelToken;
let state;
let tokenSession;

const URI_VENTA_EN_LINEA = process.env.REACT_APP_URI_VENTA_EN_LINEA;

class DomicilioId extends Component {

    getInitState = () => {
        return {
            center: null,
            start_data_monday: null,
            finsh_data_monday: null,
            start_day_fomart: null,
            finsh_day_fomart: null,
            start_day: new Date(),
            duracion: '1',
            duracion_str: "3 Meses"
        }
    }

    constructor(props) {
        super(props);
        if (tokenSession !== props.getTokenSession()) {
            state = this.getInitState();
        }
        this.state = state;
    }

    componentWillMount() {
        cancelToken = axios.CancelToken.source();
    }

    componentDidMount() {
        this.reload();
    }

    componentWillUnmount() {
        cancelToken.cancel('Component will unmount.');
        state = this.state;
        tokenSession = this.props.getTokenSession();
    }

    reload = () => {
        if (this.props.match.params) {
            this.getCenter({
                token_id: this.props.getTokenId(),
                center_id: this.props.match.params.coworkid
            });
        }
    }

    getCenter = (params) => {
        this.props.post_store(
            "/getCenterInfo",
            params,
            (response) => this.didGetCenter(response),
            (error) => this.props.handleErrorResponse(error),
            cancelToken
        );
    }

    didGetCenter = (response) => {
        var selectedDay = new Date().getDay(); // Obtiene el día de la semana (0-6, donde 0 es Domingo)
        var nextMonday = new Date();
        var daysToAdd = 0;

        if (selectedDay >= 0 && selectedDay <= 2) { // Lun, Mar, Mier
            daysToAdd = (1 + 7 - selectedDay);
        } else if (selectedDay >= 3 && selectedDay <= 5) { // Jueves, Viernes
            daysToAdd = (1 + 7 - selectedDay + 7);
        } else { // Otros días
            daysToAdd = 1;
        }
        const next_Monday = nextMonday.setDate(nextMonday.getDate() + daysToAdd);
        const start_data_monday = moment(next_Monday).format('DD/MM/YYYY')
        const new_date = moment(next_Monday).format('MM/DD/YYYY')
        var enddate = moment(new_date)
        if (this.state.duracion === '1') {
            enddate.add(3, 'months').format('YYYY/MM/DD')
        } else if (this.state.duracion === '2') {
            enddate.add(6, 'months').format('YYYY/MM/DD')
        } else if (this.state.duracion === '3') {
            enddate.add(12, 'months').format('YYYY/MM/DD')
        }
        const finsh_data_monday = moment(enddate, 'YYYY/MM/DD').format('DD/MM/YYYY')
        this.setState({
            start_data_monday: start_data_monday,
            finsh_data_monday: finsh_data_monday,
            center: response
        })
    }

    handleDateChange = (date) => {
        var Is_Sunday = moment(date, "YYYY-MM-DD HH:mm:ss")

        if (Is_Sunday.format('dddd') === 'Sunday') {
            alert('Favor de Selecionar un dia diferente');
            return false;
        }

        var selectedDay = new Date(date).getDay();
        var nextMonday = new Date(date);
        var daysToAdd = 0;

        if (selectedDay >= 0 && selectedDay <= 2) { // Lun, Mar, Mier
            daysToAdd = (1 + 7 - selectedDay);
        } else if (selectedDay >= 3 && selectedDay <= 5) { // Jueves, Viernes
            daysToAdd = (1 + 7 - selectedDay + 7);
        } else { // Otros días
            daysToAdd = 1;
        }

        const next_Monday = nextMonday.setDate(nextMonday.getDate() + daysToAdd);
        const new_date = moment(next_Monday).format('MM/DD/YYYY')
        var enddate = moment(new_date)

        if (this.state.duracion === '1') {
            enddate.add(3, 'months').format('YYYY/MM/DD')
        } else if (this.state.duracion === '2') {
            enddate.add(6, 'months').format('YYYY/MM/DD')
        } else if (this.state.duracion === '3') {
            enddate.add(12, 'months').format('YYYY/MM/DD')
        }

        const start_data_monday = moment(next_Monday).format('DD/MM/YYYY')
        const finsh_data_monday = moment(enddate, 'YYYY/MM/DD').format('DD/MM/YYYY')

        this.setState({
            start_day: new_date,
            start_data_monday: start_data_monday,
            finsh_data_monday: finsh_data_monday,
        });
    }

    handleDurationChange = (event) => {
        var startdate = this.state.start_data_monday;
        var enddate = moment(startdate)
        
        if (event.target.value === '1') {
            enddate.add(3, 'months').format('YYYY/MM/DD')
            this.setState({ duracion_str: "3 Meses" })
        } else if (event.target.value === '2') {
            enddate.add(6, 'months').format('YYYY/MM/DD')
            this.setState({ duracion_str: "6 Mesese" })
        } else if (event.target.value === '3') {
            enddate.add(12, 'months').format('YYYY/MM/DD')
            this.setState({ duracion_str: "12 Mesese" })
        }
        const finsh_data_monday = moment(enddate).format('MM/DD/YYYY')
        this.setState({
            duracion: event.target.value,
            finsh_data_monday: finsh_data_monday
        });
    }

    renderDomicilioContainer = () => {
        const { t } = this.props;
        const center = this.state.center;
        const duracion = this.state.duracion ? this.state.duracion : null;
        const today = new Date();
        const min_date = moment(today, 'MM/DD/YYYY').format('YYYY-MM-DD')
        const new_date = moment(this.state.start_day, 'MM/DD/YYYY').format('YYYY-MM-DD')
        
        return (
            <div className="container-room">
                <div className="container-room-header card-panel panel panel-default card">
                    <div className="panel-heading card-panel-heading" style={{ backgroundImage: 'url("https://api.iosoffices.com/apiosfera/v4/src/uploads/cowork_imagenes/'+ center.id + '")'}}>
                    </div>
                    <div className="card-panel-body">
                        <div className="panel-body-title">
                            <h4 className="ioscentro">{center.centro_name.toUpperCase()}</h4>
                        </div>
                        <div className="panel-body-description">
                        </div>
                        <div className="row">
                            {center ? (
                                <div className="col-xl-8 col-lg-8 col-md-8 col-sm-8 col-8 center_direccion" style={{ margin: '15px', textAlign: "left" }}>
                                    <div className="row row_direccion">
                                        <div className="center_dirrecion_plus">
                                            <p>
                                                {center.direccion}
                                                <br></br>
                                                {center.ciudad}
                                                <br></br>
                                                {center.estado}
                                                <br></br>
                                                {center.cp}
                                            </p>
                                        </div>
                                        <div className="visible-xs center_logo">
                                            {center.centros_clasificacion === 'Plus' ? (
                                                <img className="img-responsive media-object" alt="logo_categoria" src={LogoPlus} />
                                            ) : null}

                                            {center.centros_clasificacion === 'Pro' ? (
                                                <img className="img-responsive media-object" alt="logo_categoria" src={LogoPro} />
                                            ) : null}

                                            {center.centros_clasificacion === 'Start' ? (
                                                <img className="img-responsive media-object" alt="logo_categoria" src={Logostart} />
                                            ) : null}
                                            <h4 className="ioscentro text-center">
                                                {center.centros_clasificacion}
                                            </h4>
                                        </div>
                                    </div>
                                </div>
                            ) : null}
                            <div className="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-2 hidden-xs" style={{ margin: '15px', textAlign: "left" }}>
                                {center.centros_clasificacion === 'Plus' ? (
                                    <img className="img-responsive media-object" alt="logo_categoria" src={LogoPlus} />
                                ) : null}

                                {center.centros_clasificacion === 'Pro' ? (
                                    <img className="img-responsive media-object" alt="logo_categoria" src={LogoPro} />
                                ) : null}

                                {center.centros_clasificacion === 'Start' ? (
                                    <img className="img-responsive media-object" alt="logo_categoria" src={Logostart} />
                                ) : null}
                                <h4 className="ioscentro text-center">
                                    {center.centros_clasificacion}
                                </h4>
                            </div>
                        </div>
                        <div className="panel-body-bottom-cowork">
                            <div className="panel-body form-group">
                                <Link
                                    to={{
                                        pathname: "coworkpayment/" + center.id,
                                        state: {
                                        }
                                    }}
                                >
                                    <button
                                        className="btn btn-block btn-primary  btn-singup btn_create"
                                        type="button">
                                        PAGAR Y RESERVAR AHORA
                                    </button>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="container_direction_mapa">
                    <div className="col-md-6">
                        <fieldset>
                            <div className="form-group">
                                <label htmlFor="duration">
                                    {t('dashboard.reservations.label_duration')}
                                </label>
                                <select
                                    className="form-control"
                                    id="duration"
                                    onChange={this.handleDurationChange}
                                    required
                                    value={duracion}>
                                    <option value={'0'}>{'Seleccionar una opción'}</option>
                                    <option value={'1'}>{'Rentar por 3 Meses'}</option>
                                    <option value={'2'}>{'Rentar por 6 Meses'}</option>
                                    <option value={'3'}>{'Rentar por 12 Meses'}</option>
                                </select>
                            </div>
                            <div className="form-group">
                                <label htmlFor="date">
                                    {t('dashboard.reservations.label_date')}
                                </label>
                                <input
                                    autoComplete="off"
                                    className="form-control"
                                    onChange={(e) => this.handleDateChange(e.target.value)}
                                    placeholder={t('dashboard.reservations.holder_date')}
                                    required
                                    type="date"
                                    min={min_date}
                                    value={new_date} />
                            </div>
                            <div className={this.props.error ? "" : "hidden"}>
                                <div className="form-group">
                                    <div className="alert alert-warning">
                                        {this.props.error}
                                        <i className="glyphicon glyphicon-remove pull-right" onClick={this.props.handleClearError} />
                                    </div>
                                </div>
                            </div>
                        </fieldset>
                    </div>
                    <div className="col-md-6">
                        <div className="panel-body">
                            {center ? (
                                <div className="contenedor-flexbox">
                                    <div className="contenedor">
                                        <i className="fa fa-map-marker" aria-hidden="true"></i>
                                        {" "}{center.ciudad},{center.estado}
                                    </div>
                                    <div className="contenedor">
                                        <i className="fa fa-calendar-o" aria-hidden="true"></i>
                                        {" "}{this.state.duracion_str}
                                    </div>
                                    <div className="contenedor">
                                        <i className="fa fa-calendar" aria-hidden="true"></i>
                                        {" "}{this.state.start_data_monday}
                                    </div>
                                    <div className="contenedor">
                                        <i className="fa fa-calendar" aria-hidden="true"></i>
                                        {" "}{this.state.finsh_data_monday}
                                    </div>
                                    {center.name ? (
                                        <div className="contenedor">
                                            <i className="fa fa-building-o" aria-hidden="true"></i>
                                            {" "}{center.name}
                                        </div>
                                    ) : null}
                                </div>
                            ) : null}
                        </div>
                        <div>
                            <div className="contenedor-flexbox">
                                <div className="col-xs-12 text-primary">
                                    <div className="col-xs-6">
                                        <p>{t('dashboard.room_payment.subtotal')}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="form-group">
                        <Link
                            to={{
                                pathname: "Domiciliopayment/" + center.id,
                                state: {
                                    domicilioComercial: center.id,
                                    centro_id: center.id,
                                    duracion_str: this.state.duracion_str,
                                    duracion: this.state.duracion,
                                    start_day_fomart:  this.state.start_data_monday,
                                    finsh_day_fomart:  this.state.finsh_data_monday,
                                    start_day: this.state.start_day,
                                }
                            }}
                        >
                            <button
                                className="btn btn-block btn-primary  btn-singup btn_create"
                                type="submit">
                                PAGAR Y RESERVAR AHORA
                            </button>
                        </Link>
                        <div className={this.props.isSearching ? "demo-container" : "hidden"}>
                            <div className="progress-bar">
                                <div className="progress-bar-value"></div>
                            </div>
                        </div>
                    </div>
                    <div className="form-group">
                        <Link
                            to={{
                                pathname: `${URI_VENTA_EN_LINEA}/reservations_cowork/`,
                                state: {
                                    centro_id: center ? center.id : null
                                }
                            }}
                        >
                            <button
                                className="btn btn-primary btn-search-resvations-ruturn"
                                type="submit"
                                style={{ margin: '0px' }}>
                                Regresar
                            </button>
                        </Link>
                        <div className={this.props.isSearching ? "demo-container" : "hidden"}>
                            <div className="progress-bar">
                                <div className="progress-bar-value"></div>
                            </div>
                        </div>
                    </div>
                    <div className="form-group">
                        <button
                            className="btn btn-lg btn-primary btn-singup-help"
                            type="button"
                            style={{ margin: "0px" }}
                            onClick={() => $('#btnSuccessHelp').click()}
                        >
                            <span>
                                ¿Necesitas ayuda?
                            </span>
                        </button>
                    </div>
                </div>
            </div>
        )
    }

    handleErrorResponse = (error) => {
        alert(error)
    }

    rebderHelperContainer = () => {
        return (
            <HelpContainer />
        )
    }

    render() {
        const { t } = this.props;
        return (
            <div className="content-resvations">
                <div className="container-resvations-title">
                    <div className="row">
                        <h2 className="page-header">{t('dashboard.reservations.heading')}</h2>
                    </div>
                </div>
                {this.state.center ? (
                    this.renderDomicilioContainer()
                ) : null}
                {this.rebderHelperContainer()}
            </div>
        )
    }

}

export default compose(
    translate('common'),
    withRouter
)(DomicilioId);


// WEBPACK FOOTER //
// ./src/store/Domicilio/DomicilioId.js